module.exports = __webpack_public_path__ + "static/hc2-lightning-138663ba9848affdd6a630f0cd178e55.jpg";